<template>
    <div class="container grid grid-cols-1 lg:grid-cols-2 gap-8 lg:items-start" >
        <!-- Finding a Schedule -->
        <TrackingCode ref="tracking" @findResults="getResults"></TrackingCode>

        <!-- Results -->
        <Results v-if="results" :results="results"></Results>
    </div>
</template>

<script>
    import axios from 'axios';
    import TrackingCode from "./TrackingCode.vue";
    import Results from "./Results.vue";

    /**
        title: Tracking Form
        data: {
			- results: The results from the TrackingCode component
		}
        components: {
            - TrackingCode: Fields for the tracking code
            - Results: The results from the Tracking Code form
        }
        methods: {
            - getResults: Get the results from the tracking code
        }
    **/
    export default {
        data: function() {
            return {
                results: null,
            };
        },
        components: {
            TrackingCode,
            Results,
        },
        methods: {
            getResults: function(data)
            {
                this.results = data;
            },

        }
    };
</script>
